import { api, appUserAuth } from "./api";

export const WELCOME_FLAG = "ex_show_welcome";

export const progressEvent = (event, meta) => {
  if (!appUserAuth.isLoggedIn()) return Promise.resolve();
  return api.post("/app/progress/event", { event, meta: meta || null }).catch(() => {});
};

export const laneFromLabel = (label = "") => {
  const l = label.toLowerCase();
  return l.includes("annuity") || l.includes("fia") ? "annuity" : l.includes("whole life") ? "whole_life" : "iul";
};

export const LANE_NAME = { annuity: "Guaranteed Income (Fixed-Indexed Annuity)", iul: "Tax-Free Growth (IUL)", whole_life: "Guaranteed Legacy (Whole Life)" };

export const STATUS_LABEL = { not_started: "Not started", in_progress: "In progress", done: "Done" };

export const BOOK_LABEL = "Book an Illustration Review (Leon)";
export const BOOK_FEE_LINE = "$100 refundable booking fee. No pressure. You'll leave with real numbers and a clear yes/no.";
